// removed by extract-text-webpack-plugin
module.exports = {"this":"_3jkza5u3bkv57817d2msu16qp1s3tyxgtgpvwstq26mdkzh7pjdbmkwte6ujgha663u5kw78d5jjjhgtq7p5ze7ch48qzqwqdmj7k62-InputSelect-module-this","button":"_233szvzu844qypk8abdez3r31n95agstwewm5eckcg8ca9egc2nwntvqm6tgq7k9c2yee8ptuhn96tsxhkn3njv3unajr1vshaspacc-InputSelect-module-button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InputSelect/InputSelect.module.scss
// module id = 608
// module chunks = 0